import { ReactNode } from 'react';

import cx from 'classnames';

import { noop } from 'helpers/utils';
import { TickIcon } from 'styles/assets/icons';

import styles from './IndiaOrGlobalModal.module.scss';

const Card = ({
  title,
  children,
  logo,
  onClick,
  isActive,
  'data-testid': dataTestId,
  className,
}: {
  title: string;
  children: ReactNode;
  logo: ReactNode;
  onClick: () => void;
  isActive: boolean;
  className?: string;
  'data-testid'?: string;
}) => {
  return (
    (<div
      data-testid={dataTestId}
      className={cx(
        'flex-set flex--align-items-center relative',
        styles.card,
        {
          [styles.active]: isActive,
        },
        className
      )}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={noop}
      data-palette="Card">
      <div
        className={cx(
          styles.logo,
          'flex-set flex--align-items-center flex--content-center'
        )}
      >
        {logo}
      </div>
      <div className={styles.textContainer}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{children}</p>
      </div>
      {isActive && (
        <div className={styles.activeIndicator} data-palette="Card">
          <TickIcon />
        </div>
      )}
    </div>)
  );
};

export default Card;
